// extracted by mini-css-extract-plugin
module.exports = {"layoutBox":"Base64Tool_layoutBox__1imt1","center":"Base64Tool_center__J2S-1","title":"Base64Tool_title__t7Lyj","flexList":"Base64Tool_flexList__3Eb4R"};